
import { Form, TextField, PasswordField, SelectOption } from "../util";
import { defineComponent } from "vue";
import { mapActions } from "vuex";
import hash from "object-hash";

import { UserBody } from "@/domain/params";
import {
  clinicService,
  userService
} from "@/domain/services";
import { OptionSelect } from "@/presentation/models";

type ComponentData = {
  user_id?: number;
  acting_id?: number;
  isLoading: boolean;
  field_valid: { [field: string]: boolean };
  body: UserBody;
  body_hash?: string;
  acting_body_hash?: string;
  select_options: {
    clinics: OptionSelect[];
  };
};

export default defineComponent({
  name: "UserForm",
  components: { Form, TextField, PasswordField, SelectOption },
  data(): ComponentData {
    const user_id = Number(this.$route.params.user_id);
    return {
      user_id,
      isLoading: false,
      field_valid: {
        name: !!user_id,
        email: !!user_id,
        username: !!user_id,
        clinic: !!user_id,
      },
      body: {
        name: "",
        username: "",
        email: "",
        clinic_id: 0
      },
      select_options: {
        clinics: [],
      },
    };
  },
  async created() {
    await this.populateSelects();
    if (this.user_id) await this.loadUser(this.user_id);
  },
  computed: {
    isFormValid() {
      for (let field_name in this.field_valid)
        if (!this.field_valid[field_name]) return false;
      return true;
    },
  },
  methods: {
    loadUser(user_id: number) {
      this.isLoading = true;
      return userService
        .getById(user_id)
        .then((user) => {
          this.isLoading = false;
          this.body = {
            name: user.name,
            email: user.email,
            username: user.username,
            password: "",
            clinic_id: user.clinic_id
          };

          this.body_hash = hash(this.body);
        })
        .catch(() => {
          this.$router.push("/users");
        });
    },
    save() {
      this.isLoading = true;
      const payload = this.body; 

      if (!payload.password) delete payload.password;

      if (this.user_id && this.body_hash != hash(this.body)) {
        return userService
          .update(this.user_id, payload)
          .then(() => {
            this.reloadUsers();
            this.$router.push("/users");
          })
          .catch(() => {
            this.isLoading = false;
          });
      } else if (!this.user_id)
        return userService
          .create(payload)
          .then(() => {
            this.reloadUsers();
            this.$router.push("/users");
          })
          .catch(() => {
            this.isLoading = false;
          });
          this.reloadUsers();
          this.$router.push("/users");
    },
    closeModal(e: Event) {
      if (
        e.target == this.$refs.modal_mask ||
        e.target == this.$refs.close_modal
      )
        this.$router.push("/users");
    },
    updateValidation(field: string, valid: boolean) {
      this.field_valid[field] = valid;
    },
    async populateSelects() {
      await clinicService.load().then((clinics) => {
        this.select_options.clinics = clinics.map((c) => ({
          value: c.id,
          label: c.name,
        }));
      });
    },
    ...mapActions({ reloadUsers: "users/load" }),
  },
});
